import type { MoneyValue } from '../api/types';

/**
 * Subledger snapshots return money as plain JSON numbers, while the shared `Money` component works
 * with the `MoneyValue` shape used by the ledger endpoints. This adapts between the two.
 */
export function money(amount: number, currency: string): MoneyValue {
  return { amount: String(amount), currency };
}

const successStatuses = new Set([
  'Posted', 'Paid', 'Applied', 'Confirmed', 'Accepted', 'Matched', 'Deposited', 'Active', 'Verified', 'Validated', 'Released', 'Settled', 'Closed',
]);
const positiveStatuses = new Set(['Approved', 'Submitted', 'Counted', 'Sealed', 'InTransit', 'InReview', 'Open', 'Staged']);
const warningStatuses = new Set(['PartiallyPaid', 'PendingVerification', 'Unmatched', 'Suspended', 'Duplicate']);
const dangerStatuses = new Set(['Voided', 'Reversed', 'Rejected', 'Cancelled', 'Frozen', 'Excluded', 'Inactive']);

export type DocumentTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger';

export function documentTone(status: string): DocumentTone {
  if (successStatuses.has(status)) return 'success';
  if (positiveStatuses.has(status)) return 'info';
  if (warningStatuses.has(status)) return 'warning';
  if (dangerStatuses.has(status)) return 'danger';
  return 'neutral';
}

/** Sums a numeric projection, keeping the reduce logic out of the presentation components. */
export function sumBy<T>(items: readonly T[], select: (item: T) => number): number {
  return items.reduce((total, item) => total + select(item), 0);
}
